// Shared constants for the multi-level CML condition coloring feature (AVA-348).
// Frozen enum-like objects replace magic-string identifiers across useLevelColoring.js,
// cmlColoringService.js, and InspectionFiltersDrawer.vue. Values MUST equal the literals
// they replace (behavior-preserving refactor).

// Coloring level — the drawer's `level` data value.
export const LEVEL = Object.freeze({
  INSPECTION: 'inspection',
  MASTER: 'master',
  CML: 'cml',
});

// Metric key — the drawer's `metricKey` data value + useLevelColoring METRIC map keys.
export const METRIC_KEY = Object.freeze({
  CORR_RATE: 'CorrRate',
  REM_LIFE: 'RemLife',
  THICKNESS: 'Thickness',
  STATUS: 'Status',
});

// CmlConditionRating enum names (backend wire values + Status bucket keys).
export const CONDITION_RATING = Object.freeze({
  ACCEPTABLE: 'Acceptable',
  MONITOR: 'Monitor',
  RE_INSPECT: 'ReInspect',
  FFS_REQUIRED: 'FfsRequired',
  REPAIR_REQUIRED: 'RepairRequired',
  NO_DATA: 'NoData',
});

// Severity-ordered condition names (index === CmlConditionRating numeric value 0..4).
// NoData intentionally excluded — an out-of-range index yields undefined.
export const CONDITION_RATING_ORDER = Object.freeze([
  CONDITION_RATING.ACCEPTABLE,
  CONDITION_RATING.MONITOR,
  CONDITION_RATING.RE_INSPECT,
  CONDITION_RATING.FFS_REQUIRED,
  CONDITION_RATING.REPAIR_REQUIRED,
]);

// No-data / unknown / neutral color — SINGLE SOURCE OF TRUTH (SSOT) for every no-data
// surface: the Condition assessment "No data" bucket, the 3D CML/TML markers, and the
// CML/TML quick-settings display dots. Grey, tonally aligned with the monitor palette.
// Do NOT hardcode this hex elsewhere — import NO_DATA_COLOR so all surfaces move together.
export const NO_DATA_COLOR = '#9E9E9E';

// Ghost / backdrop grey — at CML level the master's full element is painted this color as a
// dimmed backdrop, then the placed CML elements paint over it in their condition colors.
// Matches createGrayMaterial's 0.75 grey (forgeUtils.js). AVA-348.
export const GHOST_COLOR = '#BFBFBF';
